<template>
  <div class="action-panel">
    <v-row class="pt-0 px-2 fill-height" ref="actionPanel" align="center" justify="space-around" no-gutters>
      <!-- <div v-for="(action, index) in actions" :key="'action-'+index"> -->
        <div
        class="action-panel__button text-center"
        :class="[ isActive === index ? 'active--action' : '']"
        @click="handleClickAction(action.callback, action.name)"
        v-for="(action, index) in filterByUserRole"
        :key="'action-'+index"
        >
          <template v-if="action.isFeatherIcon != null">
            <component size="2x" style="color: rgba(0,0,0,.54);" :is="action.icon"></component>
          </template>
          <v-icon v-else :size="30">{{ action.icon }}</v-icon>
          <br>
          <div class="action-name">{{ action.name }}</div>
        </div>
        <slot name="extraButtons"></slot>
      <!-- </div> -->
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ActionPanel',
  components: {},
  props: {
    actions: Array,
    selectedView: String
  },
  data () {
    return {
      width: null,
      isActive: false
    }
  },
  computed: {
    ...mapGetters([
      'getLoggedInUserRole'
    ]),
    isCompact () {
      // TODO removed ask Mickal about it
      const WIDTH_OF_BTN = 20 // smallest width of action button with text
      if (this.actions.length * WIDTH_OF_BTN > this.width) {
        return true
      } else {
        return false
      }
    },
    filterByUserRole () {
      const userRole = this.getLoggedInUserRole
      const actions = this.actions.filter((action) => {
        if (action.roles != null) {
          if (action.roles.indexOf('all') >= 0) {
            return true
          } else if (action.roles.indexOf(userRole) >= 0) {
            return true
          }
          return false
        }
        return true
      })
      return [...actions]
    }
  },
  methods: {
    getWidth () {
      this.width = this.$refs.actionPanel.clientWidth
    },
    handleClickAction (callback, activeActionName) {
      callback()
      // this.$nextTick(() => {
      //   const index = this.filterByUserRole.findIndex(({ name }) => name === activeActionName)
      //   this.isActive = index
      // })
    }
  },
  mounted () {
    this.width = this.$refs.actionPanel.clientWidth
  },
  created () {},
  watch: {
    actions: {
      deep: true,
      immediate: true,
      handler (val, oldVal) {
        this.$nextTick(() => {
          const index = this.filterByUserRole.findIndex(({ key }) => key === this.selectedView)
          this.isActive = index
        })
      }
    }
  }
}
</script>
